import PageShell from "@/components/PageShell";

const SECTIONS = [
  { t: "Başlangıç", d: "Coinbuy hesabınızı oluşturun, API anahtarlarınızı alın ve ilk ödemenizi TL cinsinden oluşturun. Sistem güncel kur üzerinden kripto karşılığını otomatik hesaplar." },
  { t: "Ödeme Akışı", d: "Ödeme oluşturuldu → bekleniyor → algılandı → blockchain doğrulanıyor → onaylandı. Her adım hem dashboard'da hem webhook ile takip edilebilir." },
  { t: "Ödeme Linkleri", d: "Kod yazmadan ürün bazlı ödeme linkleri oluşturun ve müşterilerinizle paylaşın." },
  { t: "Cüzdan ve Para Çekme", d: "Onaylanan ödemeler coin bazında bakiyenize eklenir. Bakiyenizi desteklenen ağlar üzerinden kendi cüzdanınıza çekebilirsiniz." },
  { t: "Komisyon", d: "Coinbuy, platform üzerinden gerçekleştirilen başarılı işlemler üzerinden %1 platform hizmet komisyonu tahsil eder. Bekleyen, başarısız veya süresi dolan işlemlerden komisyon alınmaz." },
];

export default function Docs() {
  return (
    <PageShell title="Dokümantasyon" subtitle="Coinbuy platformunu kullanmaya başlamak için kapsamlı rehber.">
      <div className="space-y-4">
        {SECTIONS.map((s, i) => (
          <div key={s.t} className="rounded-2xl border border-border bg-card p-6">
            <div className="flex items-start gap-4">
              <span className="shrink-0 grid h-8 w-8 place-items-center rounded-lg bg-primary/10 text-sm font-bold text-primary">{i + 1}</span>
              <div>
                <h3 className="text-base font-bold">{s.t}</h3>
                <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">{s.d}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </PageShell>
  );
}
